import { router } from '@/router';
import { store } from '@/store';
import AuthApi from '@api/AuthApi';
import axios from 'axios';

export default function() {
    // Create Axios object.
    let api = axios.create({
        baseURL: `${process.env.VUE_APP_API_URL}/v1`,
        timeout: 10000,
        headers: {
            'Authorization': 'Bearer ' + store.getters.apiKey,
            'Content-Type': 'application/json',
        }
    });

    // Global error handler used to refresh API key.
    api.interceptors.response.use(null, (error) => {
        let message = error?.response?.data?.message;
        if (error.response.status === 401 && message === 'token.expired') {
            // API key is expired.
            if (store.getters.refreshing) {
                // Try again.
                return api.request(error.config);
            } else if (error.config.headers['Authorization'] !== 'Bearer ' + store.getters.apiKey) {
                // Try again.
                error.config.headers['Authorization'] = 'Bearer ' + store.getters.apiKey;
                return api.request(error.config);
            } else {
                // Refresh API key.
                store.commit('refreshing', true);
                return AuthApi.refresh()
                    .then((response) => {
                        store.commit('setApiKey', response.data.data);
                        store.commit('refreshing', false);
                        error.config.headers['Authorization'] = 'Bearer ' + response.data.data;
                        return api.request(error.config);
                    }, () => {
                        // Log out.
                        store.commit('refreshing', false);
                        store.commit('logout');
                        return router.push({ name: 'login' });
                    });
            }
        } else if (error.response.status === 401) {
            // API key is invalid.
            if (store.getters.refreshing) {
                // Try again.
                return api.request(error.config);
            } else if (error.config.headers['Authorization'] !== 'Bearer ' + store.getters.apiKey) {
                // Try again.
                error.config.headers['Authorization'] = 'Bearer ' + store.getters.apiKey;
                return api.request(error.config);
            } else {
                // Log out.
                store.commit('logout');
                return router.push({ name: 'login' });
            }
        }
        // Return the error.
        return Promise.reject(error);
    });

    return api;
}
